import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { TreeViewItem } from './fc-tree.types';

@Injectable({
  providedIn: 'root'
})
export class TreeViewService {
  public checkAll$ = new Subject<void>();
  public checked$ = new Subject<TreeViewItem>();
}
